import axios from 'axios'
const { VUE_APP_API_URL } = process.env
export const getObjType = obj => {
  const toString = Object.prototype.toString
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object',
  }
  if (obj instanceof Element) {
    return 'element'
  }
  return map[toString.call(obj)]
}
/**
 * 对象深拷贝
 */
export const deepClone = data => {
  const type = getObjType(data)
  let obj
  if (type === 'array') {
    obj = []
  } else if (type === 'object') {
    obj = {}
  } else {
    // 不再具有下一层次
    return data
  }
  if (type === 'array') {
    for (let i = 0, len = data.length; i < len; i++) {
      delete data[i].$parent
      obj.push(deepClone(data[i]))
    }
  } else if (type === 'object') {
    for (const key in data) {
      delete data.$parent
      obj[key] = deepClone(data[key])
    }
  }
  return obj
}
/**
 * 根据指定key列表排序（无排序key的元素位置不变）
 * @param {*} list 需要排序的列表
 * @param {*} key 排序的key
 */
export function arraySort(list = [], key = '') {
  if (!key) {
    return [...list].sort((a, b) => a - b)
  }
  const arrItem = []
  const arrOld = []
  list.forEach(item => {
    if (typeof item[key] === 'number') arrItem.push(item)
    else arrOld.push(item)
  })
  arrItem.sort((a, b) => a[key] - b[key]).forEach(item => {
    arrOld.splice(item[key], 0, item)
  })
  return arrOld
}
export const sendDic = (params) => {
  const { url, query, method, resKey, props, headers, previousQuery, keyProp } = params
  return new Promise(resolve => {
    const callback = (res) => {
      const list = getObjValue(res.data, resKey)
      resolve(list)
    }
    if (props && props.apigw) {
      if (method === 'post') {
        axios.post(VUE_APP_API_URL + url, { ...query, [keyProp]: previousQuery }, { headers }).then(function (res) {
          callback(res)
        }).catch(() => [
          resolve([])
        ])
      } else {
        // const params = getSringParams(url, query)
        axios.get(VUE_APP_API_URL + url, { params: query, headers }).then(function (res) {
          callback(res)
        }).catch(() => [
          resolve([])
        ])
      }
    } else {
      if (method === 'post') {
        fetch.post(url, { ...query, [keyProp]: previousQuery }, { headers }).then(function(res) {
          callback(res)
        }).catch(() => [
          resolve([])
        ])
      } else {
        // const params = getSringParams(url, query)
        fetch.get(url, { params: query, headers }).then(function(res) {
          callback(res)
        }).catch(() => [
          resolve([])
        ])
      }
    }
  })
}
export const detailDic = (list, props = {}, type) => {
  if (!list) {
    return
  }
  const valueKey = props.value || 'value'
  const childrenKey = props.children || 'children'
  list.forEach(ele => {
    if (type === 'number') {
      ele[valueKey] = Number(ele[valueKey])
    } else if (type === 'string') {
      ele[valueKey] = ele[valueKey] + ''
    }
    if (ele[childrenKey]) {
      detailDic(ele[childrenKey], props, type)
    }
  })
  return list
}
export const getObjValue = (data, params = '', type) => {
  const list = params.split('.')
  let result = data
  if (list[0] === '' && type !== 'object') {
    return getDeepData(data)
  } else if (list[0] !== '') {
    list.forEach(ele => {
      result = result[ele]
    })
  }
  return result
}
export const getDeepData = (res) => {
  return (Array.isArray(res) ? res : (res.records ? res.records : res.data)) || []
}
export const calcCascader = (list = []) => {
  list.forEach((ele, index) => {
    if (ele.cascaderItem) {
      // 拷贝 cascaderItem
      const cascader = [...ele.cascaderItem]
      let parentProp = ele.prop
      list[index].cascader = [...cascader]
      cascader.forEach((citem, cindex) => {
        const columnIndex = index + cindex + 1
        list[columnIndex].parentProp = parentProp
        list[columnIndex].cascaderChange = ele.cascaderChange
        list[columnIndex].cascader = [...cascader].splice(cindex + 1)
        parentProp = list[columnIndex].prop
      })
    }
  })
  return list
}
/**
 * 动态获取组件
 */
export const getComponent = (type, component) => {
  // yl新组件
  if (type && type.includes('yl-')) return type.replace('yl-', '')
  // 原avue组件
  let result = 'input'
  if (!validatenull(component)) {
    result = component
  } else if (type === 'select') {
    result = 'select'
  } else if (type === 'radio') {
    result = 'radio'
  } else if (type === 'checkbox') {
    result = 'checkbox'
  } else if (['time', 'timerange'].includes(type)) {
    result = 'time'
  } else if (
    [
      'dates',
      'date',
      'datetime',
      'datetimerange',
      'daterange',
      'week',
      'month',
      'dategrpup',
      'year'
    ].includes(type)
  ) {
    result = 'date'
  } else if (type === 'cascader') {
    result = 'cascader'
  } else if (type === 'number') {
    result = 'input-number'
  } else if (type === 'password') {
    result = 'input'
  } else if (type === 'switch') {
    result = 'switch'
  } else if (type === 'rate') {
    result = 'rate'
  } else if (type === 'upload') {
    result = 'upload'
  } else if (type === 'silder') {
    result = 'silder'
  } else if (type === 'dynamic') {
    result = 'dynamic'
  } else if (type === 'icon-select') {
    result = 'icon-select'
  } else if (type === 'color') {
    result = 'color'
  } else if (type === 'network') {
    result = 'network'
  } else if (type === 'dimension') {
    result = 'dimension'
  }
  return KEY_COMPONENT_NAME + result
}

/**
 * 表格初始化值
 */

export const formInitVal = (list = []) => {
  const tableForm = {}
  const searchForm = {}
  list.forEach(ele => {
    if (
      ele.type === 'checkbox' ||
        ele.type === 'cascader' ||
        ele.type === 'dynamic' ||
        ele.type === 'dates' ||
        (ele.type === 'upload' && ele.listType !== 'picture-img') ||
        ele.multiple ||
        ele.range ||
        ele.dataType === 'array'
    ) {
      tableForm[ele.prop] = []
      if (ele.search) searchForm[ele.prop] = []
    } else if (
      ['number', 'rate', 'silder'].includes(ele.type) ||
        ele.dataType === 'number'
    ) {
      tableForm[ele.prop] = 0
      if (ele.search) {
        searchForm[ele.prop] = 0
      }
    } else {
      tableForm[ele.prop] = ''
      if (ele.search) {
        searchForm[ele.prop] = ''
      }
    }
    if (!validatenull(ele.valueDefault)) tableForm[ele.prop] = ele.valueDefault
    if (!validatenull(ele.searchDefault)) {
      searchForm[ele.prop] = ele.searchDefault
    }
  })
  return {
    tableForm,
    searchForm
  }
}

export const getPlaceholder = function(column, type) {
  const placeholder = column.placeholder
  const label = column.label
  if (type === 'search') {
    const searchPlaceholder = column.searchPlaceholder
    if (!validatenull(searchPlaceholder)) {
      return this.$lang(searchPlaceholder)
    } else {
      return this.$lang(label)
    }
  } else if (validatenull(placeholder)) {
    if (['select', 'checkbox', 'radio', 'tree'].includes(column.type)) {
      return `${this.$lang('请选择')}` //  ${this.$lang(label)}
    } else {
      return ''
    }
  }

  return this.$lang(placeholder)
}
export function validatenull(val) {
  if (typeof val === 'boolean') {
    return false
  }
  if (typeof val === 'number') {
    return false
  }
  if (val instanceof Array) {
    if (val.length === 0) return true
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true
  } else {
    if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '') {
      return true
    }
    return false
  }
  return false
}
export const KEY_COMPONENT_NAME = 'avue-'

export const getPasswordChar = (result = '', char) => {
  const len = result.toString().length
  result = ''
  for (let i = 0; i < len; i++) {
    result = result + char
  }
  return result
}

let result = ''

export const findByValue = (dic, value, props, first, isTree, dicType) => {
  props = props || {}
  const labelKey = props.label || 'label'
  const valueKey = props.value || 'value'
  const childrenKey = props.children || 'children'
  if (first) result = value
  if (validatenull(dic)) return result
  // 正常字典
  if (['string', 'number', 'boolean'].includes(typeof value)) {
    for (let i = 0; i < dic.length; i++) {
      if (dic[i][valueKey] === value) {
        result = dic[i][labelKey]
        break
      } else {
        findByValue(dic[i][childrenKey], value, props, false, isTree)
      }
    }
  } else if (value instanceof Array) {
    let index = 0
    let count = 0
    result = []
    while (count < value.length) {
      index = findArray(dic, value[count], valueKey)
      if (index !== -1) result.push(dic[index][labelKey])
      else result.push(value[count])
      if (isTree) dic = dic[index][childrenKey]
      count++
    }
    result = result.join(',').toString()
  }
  return result
}
/**
 * 根据字典的value查找对应的index
 */
export const findArray = (dic, value, valueKey) => {
  valueKey = valueKey || 'value'
  for (let i = 0; i < dic.length; i++) {
    if (dic[i][valueKey] === value) {
      return i
    }
  }
  return -1
}
export const setPx = (val, defval = '') => {
  if (validatenull(val)) val = defval
  if (validatenull(val)) return ''
  val = val + ''
  if (val.indexOf('%') === -1) {
    val = val + 'px'
  }
  return val
}
export const vaildData = (val, dafult) => {
  if (typeof val === 'boolean') {
    return val
  }
  return !validatenull(val) ? val : dafult
}
